import React from 'react';
import axios from '../helpers/axiosConfig';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Pour la navigation

function User() {
  const [listUser, setListUsers] = useState([]);

  useEffect(() => {
    axios.get('/auth').then((response) => {
      setListUsers(response.data);
    });
  }, []);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('/auth');
      setListUsers(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des utilisateurs", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) return;

    try {
      await axios.delete(`/auth/${id}`);
      // Retirer l’utilisateur supprimé de la liste sans recharger la page
      setListUsers(listUser.filter((user) => user.id !== id));
      alert("Utilisateur supprimé avec succès !");
    } catch (error) {
      console.error("Erreur lors de la suppression", error);
      alert("Une erreur est survenue lors de la suppression de l'utilisateur.");
    }
  };

  return (
    <div className="container mt-5 pt-4 ">
      <a href="/createdusers" className="btn btn-primary">
        Creation utilisateur
      </a>
      <div>Liste des Utilisateur</div>
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <td>#</td>
            <td>Login</td>
            <td>Roles</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          {listUser.map((element, k) => {
            return (
              <tr key={k}>

                <td> {element.id} </td>
                <td> {element.username} </td>
                <td> {element.roles} </td>
                <td>
                  <Link className="text-primary" to={`/auth/edit/${element.id}`}>
                    <i className="fa fa-edit"></i>
                  </Link>
                  {/* <Link className="text-danger ml-3" to={`/auth/delete/${element.id}`}>
                    <i className="fa fa-trash"></i>
                  </Link> */}
                  <button
                    className="btn btn-link text-danger ml-3 p-0"
                    onClick={() => handleDelete(element.id)}
                  >
                    <i className="fa fa-trash"></i>
                  </button>

                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default User;
